"use client";

/**
 * Makes a route-backed tab acknowledge pointer or keyboard intent before the
 * destination route commits. Tabs owns the visual treatment; this helper owns
 * the single-pending-trigger invariant shared by route-backed tab families.
 */
export function markTabSelectionPending(trigger: HTMLElement) {
  if (
    trigger.dataset.state === "active"
    || trigger.dataset.selectionPending === "true"
  ) {
    return;
  }

  const tabList = trigger.closest('[role="tablist"]');
  tabList?.querySelectorAll<HTMLElement>('[data-selection-pending="true"]')
    .forEach(pendingTrigger => pendingTrigger.removeAttribute("data-selection-pending"));
  trigger.dataset.selectionPending = "true";
}
